import { NgModule } from '@angular/core';
import { PerfilEdicaoComponent } from './perfil-edicao/perfil-edicao.component';
import { PerfilFrmComponent } from './perfil-frm/perfil-frm.component';
import { PerfilListaComponent } from './perfil-lista/perfil-lista.component';
import { PerfilRoutingModule } from './perfil.routing';
import { PerfilService } from './perfil.service';
import { AppSharedModule } from '../app-shared.module';


@NgModule({
  imports: [
    AppSharedModule
  ],
  declarations: [
    PerfilFrmComponent,
    PerfilEdicaoComponent,
    PerfilListaComponent
  ],
  exports: [
    PerfilRoutingModule
  ],
  providers: [
    PerfilService
  ]
})
export class PerfilModule { }
